import { Button } from "primereact/button";
import { Link } from "react-router-dom";
import localeText from "../../../../../locale";
import { formatPrice } from "../../../../../utilities/formatPrice";

const ExtracreditTransferStep3Summary = ({
  recipient,
  amount,
  fee,
  currencySymbol,
  loading,
  success,
  onBack,
  onConfirm,
}) => {
  if (success) {
    return (
      <div className="flex flex-column align-items-center gap-4 text-center">
        <div
          className="p-3"
          style={{
            backgroundColor: "var(--theme-primary, #1FC16B)",
            borderRadius: "50%",
          }}
        >
          <div
            className="flex align-items-center justify-content-center overflow-hidden"
            style={{
              width: "80px",
              height: "80px",
              backgroundColor: "var(--theme-background, #FFFFFF)",
              borderRadius: "50%",
            }}
          >
            <i className="pi pi-check text-4xl" style={{ color: "var(--theme-text-muted, #5C5C5C)" }} />
          </div>
        </div>
        <h4 className="m-0" style={{ color: "var(--theme-text, #171717)" }}>
          {localeText("transferCompleted")}
        </h4>
        <p className="text-600 m-0">
          {localeText("success")} • {new Date().toLocaleDateString()} às{" "}
          {new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}
        </p>
        <div
          className="p-3 border-round-md w-full"
          style={{ border: "1px solid var(--theme-border, #E9ECEF)", maxWidth: "400px" }}
        >
          <div className="text-sm text-600 mb-1">{localeText("totalValue")}</div>
          <div className="font-bold text-lg" style={{ color: "var(--theme-text, #171717)" }}>
            - {currencySymbol} {formatPrice(amount + (fee || 0))} ECR
          </div>{" "}
          <hr className="mt-3" style={{ borderColor: "var(--theme-border, #E9ECEF)" }} />
          <Link to="/dashboard-extracoinStatement">
            <Button
              size="small"
              label={localeText("goToStatement")}
              className="p-button-text border-round-md p-no-outline"
              style={{ color: "var(--theme-primary, #1DAF61)" }}
            />
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-column align-items-center gap-4">
      <div
        className="p-3"
        style={{
          background:
            "linear-gradient(to bottom,rgba(113, 119, 132, 0.25),rgba(113, 119, 132, 0.03))",
          borderRadius: "50%",
        }}
      >
        <div
          className="flex align-items-center justify-content-center overflow-hidden"
          style={{ width: "96px", height: "96px", backgroundColor: "#FFFFFF", borderRadius: "50%" }}
        >
          <i className="pi pi-list text-5xl" style={{ color: "var(--theme-text-muted, #5C5C5C)" }} />
        </div>
      </div>

      <div className="text-center w-full">
        <h4 className="mb-2 m-0">{localeText("transferSummary")}</h4>
        <p className="text-600 m-0">
          {localeText("transferSummaryHint") || "Revise e confirme antes de finalizar."}
        </p>
      </div>
      <div
        className="w-full p-4 border-round-md"
        style={{ border: "1px solid var(--theme-border, #E9ECEF)", maxWidth: "400px" }}
      >
        <p className="mb-3 m-0">
          {localeText("sendTo")} {recipient?.name || recipient?.username}
        </p>
        <div className="text-2xl font-bold mb-4" style={{ color: "var(--theme-text, #171717)" }}>
          {currencySymbol} {formatPrice(amount)} ECR
        </div>
        <div className="text-sm text-600 mb-2 uppercase">{localeText("recipientDetails")}</div>
        <div className="mb-2">
          <span className="text-600">{localeText("recipient")}: </span>
          {recipient?.name || recipient?.firstName || recipient?.username}
        </div>
        <div className="mb-2">
          <span className="text-600">{localeText("email")}: </span>
          {recipient?.email}
        </div>
        {fee != null && fee > 0 && (
          <div>
            <span className="text-600">{localeText("platformFee")}: </span>
            {currencySymbol} {formatPrice(fee)}
          </div>
        )}
        <hr className="my-4" style={{ borderColor: "var(--theme-border, #E9ECEF)" }} />
        <div className="flex gap-2">
          <Button
            size="small"
            label={localeText("backAction")}
            className="p-button-outlined border-round-md p-no-outline flex-1"
            style={{ border: "1px solid var(--theme-border, #EBEBEB)", color: "var(--theme-text-muted, #5C5C5C)" }}
            onClick={onBack}
            disabled={loading}
          />
          <Button
            size="small"
            label={localeText("transferExtracredit") || "Transferir Extracredit"}
            className="border-round-md p-no-outline border-none flex-1"
            style={{ backgroundColor: "var(--theme-primary, #1DAF61)", color: "#FFFFFF" }}
            onClick={onConfirm}
            loading={loading}
            disabled={loading}
          />
        </div>
        <div className="text-xs m-0 mt-2 text-center" style={{ color: "var(--theme-text-muted, #A3A3A3)" }}>
          {localeText("transferConfirmDisclaimerBefore")}
          <span className="font-bold">{localeText("sendCredits")}</span>
          {localeText("transferConfirmDisclaimerMiddle")}
          <span className="font-bold">{localeText("companyExtraconomy")}</span>
          {localeText("transferConfirmDisclaimerAfter")}
        </div>
      </div>
    </div>
  );
};

export default ExtracreditTransferStep3Summary;
